
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kbs/TkbMessagePage/TkbMessagePage",
      function () {
        return require("private-next-pages/kbs/TkbMessagePage/TkbMessagePage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kbs/TkbMessagePage/TkbMessagePage"])
      });
    }
  